import api from '../..'

const participantIdsList = (
  area: number[] = [],
  searchText = '',
  usersFilter: any
) => {
  const params = {
    'q[g][0][m]': 'and',
    'q[g][0][lms_active_true]': true,
    'q[g][0][full_name_or_identifier_or_position_or_lms_profiles_name_or_area_name_cont]':
      searchText,
  } as any

  if (usersFilter) {
    if (usersFilter.filterType === 'simple') {
      params['q[g][1][m]'] = usersFilter.generalCondition || 'and'
      usersFilter.data.map(({ input, operator, compareTo }: any) => {
        params[`q[g][1][${input}_${operator}]`] = compareTo
      })
    }
  }
  if (area[0] !== 0) params['q[area_id_in]'] = area
  return api
    .get(`administration/users/participants`, {
      params,
    })
    .then(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
        total: parseInt(headers['total']),
        perPage: parseInt(headers['per-page']),
      }
    })
}

export default participantIdsList
